import { render, staticRenderFns } from "./ProtocoloDlg.vue?vue&type=template&id=64cf5082"
import script from "./ProtocoloDlg.vue?vue&type=script&lang=js"
export * from "./ProtocoloDlg.vue?vue&type=script&lang=js"
import style0 from "./ProtocoloDlg.vue?vue&type=style&index=0&id=64cf5082&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports